"use strict";

(function($) {
  $(function() {
    // Career taxonomy mini nav - active
    $("#nav-job-taxonomies-js .nav-link").click(function(e) {
      e.preventDefault();

      if (!$(this).hasClass("active")) {
        $("#nav-job-taxonomies-js .nav-link").removeClass("active");
        $(this).addClass("active");

        var fade_delay = 230;
        var current_career_tax = $(this).data("tax");

        $(".tile-position-row-js").fadeOut(fade_delay);
        setTimeout(function() {
          if (current_career_tax == "all") {
            $(".tile-position-col").addClass("show");
          } else {
            $(".tile-position-col").removeClass("show");
            $(".tile-position-col." + current_career_tax).addClass("show");
          }
        }, fade_delay);
        $(".tile-position-row-js").fadeIn(fade_delay);
      }
    });
  });
})(jQuery);
